import React, { useState, useContext }from 'react';
import AuthContext from '../lib/auth/AuthContext';
import {
  useNavigate,
} from "react-router-dom";
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import styled from 'styled-components'

import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import Box from '@mui/material/Box';
import HomeIcon from '@mui/icons-material/Home';
import TimelineIcon from '@mui/icons-material/Timeline';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import LogoutIcon from '@mui/icons-material/Logout';
import NewReleasesOutlinedIcon from '@mui/icons-material/NewReleasesOutlined';
import { ChangelogDialog } from './ChangelogDialog';
import NavbarSearch from './NavbarSearch';
import { MOBILE_MEDIA_QUERY } from '../styles/breakpoints';

const NavListBottom = styled.div`
  position: absolute;
  bottom: env(safe-area-inset-bottom);
  width: 100%;
`;
const NavBarDiv = styled.div`
  display: flex;
  background-color: yellow;
  z-index: 999;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  padding-left: 20px;
  padding-right: 20px;
  align-items: center;
`;


// Flex: 1 not the same as flex-grow: 1
// https://stackoverflow.com/questions/31909188/flexbox-evenly-sized-elements-regardless-of-contents
const NavBarSection = styled.div`
  flex: 1;
  display: flex;
`;

const NavBarSectionLeft = styled(NavBarSection)`
  @media ${MOBILE_MEDIA_QUERY} {
    flex: 0 0 48px;
  }
`;

const NavBarSectionMiddle = styled(NavBarSection)`
  flex: 3;
  justify-content: center;

  @media ${MOBILE_MEDIA_QUERY} {
    flex: 1;
    min-width: 0;
  }
`;

const NavBarSectionRight = styled(NavBarSection)`
  @media ${MOBILE_MEDIA_QUERY} {
    display: none;
  }
`;

const VersionTag = styled.span`
  font-size: 11px;
  color: #b1b1b1;
`;

const Navbar = () => {
  const [changelogVisible, setChangelogVisible] = useState(false);
  const navigate = useNavigate();
  const [drawerVisible, setDrawerVisible] = useState(false);

  const authContext = useContext(AuthContext);

  const onDrawerClosed = () => {
    setDrawerVisible(false);
  }

  return (
    <>
      <NavBarDiv>
      <NavBarSectionLeft>
        <IconButton
          size="large"
          edge="start"
          color="inherit"
          aria-label="menu"
          sx={{ mr: 2 }}
          onClick={() => setDrawerVisible(true)}
        >
          <MenuIcon />
        </IconButton>
      </NavBarSectionLeft>

      <NavBarSectionMiddle>
        <NavbarSearch />
      </NavBarSectionMiddle>
      
      <NavBarSectionRight>
      </NavBarSectionRight>
     </NavBarDiv>

     <Drawer
        anchor={'left'}
        open={drawerVisible}
        onClose={onDrawerClosed}
      >
        <Box
          sx={{ width: 250 }}
          role="presentation"
          onClick={() => setDrawerVisible(false)}
          >

          <List>
            <ListItem>
              <ListItemIcon>
                <AccountCircleIcon />
              </ListItemIcon>
              {authContext.user?.firstName} {authContext.user?.lastName}
            </ListItem>

            <Divider style={{marginTop: '10px', marginBottom: '25px'}}/>
            
            <ListItem key={"Home"} disablePadding>
              <ListItemButton onClick={() => navigate('/')}>
                <ListItemIcon>
                  <HomeIcon />
                </ListItemIcon>
                <ListItemText primary={"Home"} />
              </ListItemButton>
            </ListItem>

            <ListItem key={"Activations Feed"} disablePadding>
              <ListItemButton onClick={() => navigate('/activations')}>
                <ListItemIcon>
                  <TimelineIcon />
                </ListItemIcon>
                <ListItemText primary={"Activations Feed"} />
              </ListItemButton>
            </ListItem>

            <ListItem key={"Orders Feed"} disablePadding>
              <ListItemButton onClick={() => navigate('/orders')}>
                <ListItemIcon>
                  <ShoppingCartIcon />
                </ListItemIcon>
                <ListItemText primary={"Orders"} />
              </ListItemButton>
            </ListItem>
          </List>

          <NavListBottom>
            <List>
              <ListItem key={"Logout"} disablePadding>
                <ListItemButton onClick={() => authContext.signOut()}>
                  <ListItemIcon>
                    <LogoutIcon />
                  </ListItemIcon>
                  <ListItemText primary={"Logout"} />
                </ListItemButton>
              </ListItem>
              <ListItem key={"What's new"} disablePadding>
                <ListItemButton onClick={() => setChangelogVisible(true)}>
                  <ListItemIcon>
                    <NewReleasesOutlinedIcon />
                  </ListItemIcon>
                  <ListItemText primary={"What's new"} />
                </ListItemButton>
              </ListItem>
              <ListItem>
                <VersionTag>
                  Version {process.env.REACT_APP_VERSION}
                </VersionTag>
              </ListItem>
            </List>
          </NavListBottom>
        </Box>
      </Drawer>

      <ChangelogDialog
        open={changelogVisible}
        onClose={() => setChangelogVisible(false)}
      />
    </>

  );
}

export default Navbar;
